import React from 'react'
import { GridItem } from '../../../common/grid/GridItem'
import { Text } from '../../../common/text/Text'
import { Divider, makeStyles, tokens } from '@fluentui/react-components'
import { t } from '../../../../i18n/i18n'
import { formatToSwedishCrowns } from '../../../../helpers/stringHelper'
import { ConsequenceAndProbabilityRisk } from '../../../../api/schemas/schema'
import { RiskLevelBadge } from '../../RiskBadges'
import { ThreatPopover } from '../../../common/popover/ThreatPopover'
import { ProtectedAssetGoalPopover } from '../../../common/popover/ProtectedAssetGoalPopover'
import { getFullName } from '../../../../helpers/accountHelper'
import { Avatar } from '../../../common/avatar/Avatar'
import { RiskscenarioPopover } from '../../../common/popover/RiskscenarioPopover'
import TextOutput from '../../../common/inputs/TextOutput'
import { Classification20Filled, Classification20Regular } from '@fluentui/react-icons'

const useStyles = makeStyles({
   marginTopXS: {
      marginTop: tokens.spacingVerticalXS,
   },
   marginTopS: {
      marginTop: tokens.spacingVerticalS,
      marginBottom: tokens.spacingVerticalS,
   },
   popoverWrapper: {
      display: 'flex',
      justifyContent: 'space-around',
      paddingBottom: tokens.spacingVerticalM,
   },
})
type ParentConsequenceRiskInformationProps = {
   selectedRisk: ConsequenceAndProbabilityRisk
}
export const ParentConsequencedRiskInformation = ({ selectedRisk }: ParentConsequenceRiskInformationProps) => {
   const classes = useStyles()
   return (
      <>
         <GridItem size="12/12">
            <div className={classes.popoverWrapper}>
               {selectedRisk?.protectedAssetGoal?.name && <ProtectedAssetGoalPopover protectedAssetGoal={selectedRisk?.protectedAssetGoal} />}
               {selectedRisk?.threat?.name && <ThreatPopover threat={selectedRisk?.threat} />}
               {selectedRisk && <RiskscenarioPopover risk={selectedRisk} regularIcon={<Classification20Regular />} filledIcon={<Classification20Filled />} />}
            </div>
            <Divider appearance="brand" />
         </GridItem>
         <GridItem size="12/12">
            <Text style={{ margin: 0 }} weight="semibold">
               {t('RiskLevel')}
            </Text>
            <RiskLevelBadge largeBadge riskLevel={selectedRisk.riskLevel} className={classes.marginTopS} />
         </GridItem>
         <GridItem size="12/12">
            <TextOutput label={t('UnderlyingMotivationAndStand')} text={selectedRisk.underlyingAnalysisMotivation} />
         </GridItem>
         <GridItem size="12/12">
            <TextOutput label={t('ProposedAction')} text={selectedRisk.proposedAction} />
         </GridItem>
         <GridItem size="6/12">
            <Text style={{ margin: 0 }} weight="semibold">
               {t('EstimatedCost')}
            </Text>
            <Text italic={!selectedRisk.estimatedCost && selectedRisk.estimatedCost !== 0} className={classes.marginTopS}>
               {selectedRisk.estimatedCost || selectedRisk.estimatedCost === 0 ? formatToSwedishCrowns(selectedRisk.estimatedCost) + ' kr' : t('NoValueSet')}
            </Text>
         </GridItem>
         <GridItem size="6/12">
            <Text style={{ margin: 0 }} weight="semibold">
               {t('AnalysedBy')}
            </Text>
            <Avatar name={getFullName(selectedRisk.analysedBy)} className={classes.marginTopXS} />
         </GridItem>
         {selectedRisk.comment ? (
            <GridItem size="12/12">
               <Text style={{ margin: 0 }} weight="semibold">
                  {t('Comment')}
               </Text>
               <Text className={classes.marginTopS}>{selectedRisk.comment}</Text>
            </GridItem>
         ) : null}
      </>
   )
}
